import axios from "axios";

export const axiosDefault = axios.create({
  baseURL: process.env.REACT_APP_SYDLE_ONE_API,
  headers: {
    "Content-Type": "application/json"
  },
  crossdomain: true
});

export const axiosBearerSite = axios.create({
  baseURL: process.env.REACT_APP_SYDLE_ONE_API,
  headers: {
    "Authorization": `Bearer ${process.env.REACT_APP_SYDLE_ONE_SITE_TOKEN}`,
    "Content-Type": "application/json"
  },
  crossdomain: true
});

export const axiosAuthPlanos = axios.create({
  baseURL: process.env.REACT_APP_SYDLE_ONE_API,
  headers: {
    "Content-Type": "application/json"
  },
  crossdomain: true,
})

export const axiosGeolocation = axios.create({
  baseURL: 'https://extreme-ip-lookup.com/json/?key=LJGU1k3TXCI6HKIlkTxx',
  headers: {
    "Content-Type": "application/json"
  },
  crossdomain: true,
})

export const axiosRenewToken = axios.create({
  baseURL: process.env.REACT_APP_TOKEN_API,
  headers: {
    "Content-Type": "application/json"
  }
})

axiosAuthPlanos.interceptors.request.use(
  config => {
    const token = sessionStorage[process.env.REACT_APP_JWT_TOKEN_PESSOA];
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

axiosBearerSite.interceptors.request.use(
  config => {
  
    const urlFinishCandidature = config.url.indexOf("selectiveProcessSubscribe");
    const urlSubmitResume = config.url.indexOf("submitResume");
    const authUser = JSON.parse(window.sessionStorage.getItem('carrersAuthentication'));
    
    const token = ((authUser && authUser.socialNetToken && urlFinishCandidature !== -1)
    || (authUser && authUser.socialNetToken && urlSubmitResume !== -1))
    ? authUser.socialNetToken
    : process.env.REACT_APP_SYDLE_ONE_SITE_TOKEN;
    
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => Promise.reject(error)
);